import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import { AppConfigOptions, getCassiopeiaDefaultProviders } from '@web/base';
import {
  BannerStore,
  MemberFeatureResolver,
  POEditorTranslationHelper,
  provideHomePrefetch,
  SavingsStore,
  SelfServiceStore,
} from '@web/service';
import { pbuRoutes } from './app.routes';
import { pbuPageComponents } from './home/pbu-page-components';

export const getAppConfig = ({
  config,
  backendEnvironment,
  providers: extraProviders = [],
  environment,
}: AppConfigOptions): ApplicationConfig => {
  const defaultProviders = getCassiopeiaDefaultProviders({ environment, config, backendEnvironment });
  const providers = [
    ...defaultProviders,
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideAppInitializer(() => {
      inject(POEditorTranslationHelper);
    }),
    provideRouter(
      pbuRoutes(environment),
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' }),
      withComponentInputBinding(),
    ),
    { provide: MemberFeatureResolver, useValue: pbuPageComponents },
    provideHomePrefetch(SavingsStore, SelfServiceStore, BannerStore),
    ...extraProviders,
  ];

  // ['None', 'Windows'].includes(authenticationMode) && providers.push(provideTranslateEdit({
  //   translateKeyAttribute: 'data-translation-key',
  //   highlightClass: 'cas-translate-highlight',
  //   variant: authenticationMode === 'None' ? undefined : 'PBU',
  // }));

  return {
    providers,
  };
};
